import React from "react";
import {
	TBallastBackendRecord,
	EBallastRecordState,
	TBallastRecord,
} from "../../../../../redux/app/ballast/@types";
import classNames from "classnames";
import { marpolUtils } from "../../../../../redux/app/marpol";

type OwnProps = {
	ballastRecord: TBallastRecord | TBallastBackendRecord;
};
function BallastAttachmentsPrintView(props: OwnProps) {
	const { ballastRecord } = props;
	const isStrikedOff = ballastRecord.state === EBallastRecordState.STRIKED_OFF;

	const attachmentNames = ballastRecord._attachments
		? Object.keys(ballastRecord._attachments)
		: [];

	return attachmentNames.length > 0 ? (
		<tr
			className={classNames("uppercase", {
				"line-through": isStrikedOff,
			})}
			key="attachments"
		>
			<td className="relative">
				<div
					className={classNames(
						{ "line-through": isStrikedOff },
						"p-3 m-px text-sm leading-7 text-left bg-white ws-marpol-td--divfix"
					)}
				>
					<div className="h-full font-medium">{}</div>
				</div>
			</td>
			<td className="relative">
				<div
					className={classNames(
						{ "line-through": isStrikedOff },
						"p-3 m-px text-sm leading-7 text-left bg-white ws-marpol-td--divfix"
					)}
				>
					<div className="h-full font-medium">{}</div>
				</div>
			</td>
			<td className="relative">
				<div
					className={classNames(
						{ "line-through": isStrikedOff },
						"p-3 m-px text-sm font-medium leading-7 text-right text-gray-800 bg-white ws-marpol-td--divfix"
					)}
				>
					<div className="h-full font-medium">
						<div className={"px-6 py-px mr-2 text-xs rounded-sm"}>
							<span
								className={classNames(
									"text-sm",
									"text-sm bp3-icon bp3-icon-paperclip"
								)}
							/>
						</div>
					</div>
				</div>
			</td>
			<td className="relative">
				<div className="p-1 m-px text-sm font-medium leading-7 text-left text-gray-800 bg-white">
					<ol className="list-disc h-full font-medium p-2 mx-3">
						{attachmentNames.map((attachment: string) => {
							return (
								<li key={attachment}>
									<a
										href={marpolUtils.getAttachmentURL(
											attachment,
											ballastRecord.id,
											ballastRecord._rev
										)}
										target="_blank"
										rel="noreferrer"
										download
									>
										{attachment}
									</a>
								</li>
							);
						})}
					</ol>
				</div>
			</td>
		</tr>
	) : null;
}

export default BallastAttachmentsPrintView;
